// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/project',
    name: 'Project',
    component: layout,
    redirect: '/project/index',
    meta: {
      title: '项目',
      i18Key: 'router.user.project.title',
      roles: [1],
      pinned: true
    },
    sort: 0,
    children: [
      {
        path: 'index',
        name: 'ProjectIndex',
        component: () => import('@/views/Project/Index.vue'),
        meta: {
          constantLight: true,
          title: '项目',
          icon: 'i-menu:task',
          i18Key: 'router.user.project.index',
          roles: [1]
        }
      },
      {
        path: 'step',
        name: 'ProjectStep',
        component: () => import('@/views/Project/ProjectStep/Index.vue'),
        hiddenInMenu: true,
        meta: {
          title: '项目步骤',
          roles: [1]
        }
      },
      {
        path: 'promptUseList',
        name: 'PromptUseList',
        component: () => import('@/views/Project/PromptUseList/Index.vue'),
        hiddenInMenu: true,
        meta: {
          title: 'Prompt使用情况',
          roles: [1]
        }
      }
    ]
  },
  // 项目列表 创建项目内的组件当成页面显示
  {
    path: '/projectList',
    name: 'ProjectList',
    component: layout,
    redirect: '/projectList/index',
    meta: {
      roles: [1],
      i18Key: 'router.user.myProjects.index',
      category: 'setting'
    },
    sort: 30,
    children: [
      {
        path: 'index',
        name: 'projectListIndex',
        component: () => import('@/views/Project/components/ProjectList/Index.vue'),
        meta: {
          title: '项目列表',
          i18Key: 'router.user.myProjects.index',
          roles: [1]
        },
      }
    ]
  }
]
export default routes
